// hooks
import useUserToken from "@/hook/useUserToken";

// Permission constants
export const PERMISSIONS = {
  DASHBOARD: "DASHBOARD",
  // DOCUMENT_INSPECTION: "DOCUMENT_INSPECTION",
  // STATE_ENTERPRISE_MANAGEMENT: "STATE_ENTERPRISE_MANAGEMENT",
  // SEIRC_MANAGEMENT: "SEIRC_MANAGEMENT",
  // NON_FINANCIAL_EVALUATION: "NON_FINANCIAL_EVALUATION",
  // STATE_EVALUATION: "STATE_EVALUATION",

  OPERATION_PLAN: "OPERATION_PLAN",
  DELEGATION_PLAN: "DELEGATION_PLAN",
  DELEGATION_REPORT: "DELEGATION_REPORT",
  DIVIDEND_TRACKING: "DIVIDEND_TRACKING",
  STATE_ENTERPRISE_FINANCIAL_REPORT: "STATE_ENTERPRISE_FINANCIAL_REPORT",
  MANAGEMENT_LIST: "MANAGEMENT_LIST",
  INVESTED_ENTERPRISE_LIST: "INVESTED_ENTERPRISE_LIST",
  KPI_REPORT: "KPI_REPORT",
  NON_FINANCIAL_REPORT: "NON_FINANCIAL_REPORT",
  STATE_EVALUATION_REPORT: "STATE_EVALUATION_REPORT",
  LAW_MANAGEMENT: "LAW_MANAGEMENT",
  INFORMATION_MANAGEMENT: "INFORMATION_MANAGEMENT",
  CHAT_MESSAGES: "CHAT_MESSAGES",
  ADMIN_ACCOUNT_MANAGEMENT: "ADMIN_ACCOUNT_MANAGEMENT",
  ADMIN_ACCOUNT_SETTINGS: "ADMIN_ACCOUNT_SETTINGS",
  SYSTEM_USER_GUIDE: "SYSTEM_USER_GUIDE",

  //news
  COMPANY_FINANCIAL_REPORT: "COMPANY_FINANCIAL_REPORT",
  MANAGEMENT_EVALUATION_REPORT: "MANAGEMENT_EVALUATION_REPORT",
  DIRECTOR_EVALUATION_REPORT: "DIRECTOR_EVALUATION_REPORT",
  COMPANY_MANAGEMENT: "COMPANY_MANAGEMENT",
} as const;

// Action types
export interface PermissionActions {
  isRead: boolean;
  isWrite: boolean;
  isUpdate: boolean;
  isUpdateData: boolean;
  isDelete: boolean;
  isDownload: boolean;
  isUpdateStatus: boolean;
  isAddUserToGroup: boolean;
}

export interface RolePermission {
  id: string;
  roleId: string;
  permissionId: string;
  actions: PermissionActions[];
  permission: {
    id: string;
    name: string;
    displayName: string;
    description: string;
    isActive: boolean;
  };
}

export const useAccessPermission = () => {
  const user = useUserToken();
  const rolePermissions: RolePermission[] =
    user?.data?.role?.rolePermissions || [];

  // console.log("rolePermissions", rolePermissions);

  // Helper function to get actions for a permission
  const getActions = (permissionName: string): PermissionActions => {
    const permission = rolePermissions.find(
      (p) => p.permission.name === permissionName
    );
    if (!permission?.actions?.length) {
      return {
        isRead: false,
        isWrite: false,
        isUpdate: false,
        isUpdateData: false,
        isDelete: false,
        isDownload: false,
        isUpdateStatus: false,
        isAddUserToGroup: false,
      };
    }
    return permission.actions.reduce(
      (acc, action) => ({ ...acc, ...action }),
      {} as PermissionActions
    );
  };

  // Easy-to-use boolean variables for each permission
  const dashboards = getActions(PERMISSIONS.DASHBOARD);
  // const documentInspection = getActions(PERMISSIONS.DOCUMENT_INSPECTION);
  // const stateEnterpriseManagement = getActions(
  //   PERMISSIONS.STATE_ENTERPRISE_MANAGEMENT
  // );
  // const seircManagement = getActions(PERMISSIONS.SEIRC_MANAGEMENT);
  // const nonFinancialEvaluation = getActions(
  //   PERMISSIONS.NON_FINANCIAL_EVALUATION
  // );
  // const stateEvaluation = getActions(PERMISSIONS.STATE_EVALUATION);
  const operationPlan = getActions(PERMISSIONS.OPERATION_PLAN);
  const delegationPlan = getActions(PERMISSIONS.DELEGATION_PLAN);
  const delegationReport = getActions(PERMISSIONS.DELEGATION_REPORT);
  // const dividendTracking = getActions(PERMISSIONS.DIVIDEND_TRACKING);
  // const stateEnterpriseFinancialReport = getActions(
  //   PERMISSIONS.STATE_ENTERPRISE_FINANCIAL_REPORT
  // );
  const managementList = getActions(PERMISSIONS.MANAGEMENT_LIST);
  const investedEnterpriseList = getActions(
    PERMISSIONS.INVESTED_ENTERPRISE_LIST
  );
  const kpiReport = getActions(PERMISSIONS.KPI_REPORT);
  const nonFinancialReport = getActions(PERMISSIONS.NON_FINANCIAL_REPORT);
  const stateEvaluationReport = getActions(PERMISSIONS.STATE_EVALUATION_REPORT);
  const lawManagement = getActions(PERMISSIONS.LAW_MANAGEMENT);
  const informationManagement = getActions(PERMISSIONS.INFORMATION_MANAGEMENT);
  const chatMessages = getActions(PERMISSIONS.CHAT_MESSAGES);
  // const adminAccountManagement = getActions(
  //   PERMISSIONS.ADMIN_ACCOUNT_MANAGEMENT
  // );
  // const adminAccountSettings = getActions(PERMISSIONS.ADMIN_ACCOUNT_SETTINGS);
  // const systemUserGuide = getActions(PERMISSIONS.SYSTEM_USER_GUIDE);

  // news
  const company_financial_report = getActions(
    PERMISSIONS.COMPANY_FINANCIAL_REPORT
  );
  const management_evalution_report = getActions(
    PERMISSIONS.MANAGEMENT_EVALUATION_REPORT
  );
  const director_Evaluation_Report = getActions(
    PERMISSIONS.DIRECTOR_EVALUATION_REPORT
  );
  const company_management = getActions(PERMISSIONS.COMPANY_MANAGEMENT);

  return {
    // Simple access to all permissions
    dashboards,
    // documentInspection,
    // stateEnterpriseManagement,
    // seircManagement,
    // nonFinancialEvaluation,
    // stateEvaluation,
    operationPlan,
    delegationPlan,
    delegationReport,
    // dividendTracking,
    // stateEnterpriseFinancialReport,
    managementList,
    investedEnterpriseList,
    kpiReport,
    nonFinancialReport,
    stateEvaluationReport,
    lawManagement,
    informationManagement,
    chatMessages,
    // adminAccountManagement,
    // adminAccountSettings,
    // systemUserGuide,

    company_financial_report,
    management_evalution_report,
    director_Evaluation_Report,
    company_management,
  };
};
